<div class="producer-flow-shell" [class.popup-mode]="isPopupMode" [class.layout-mode]="!isPopupMode">
  <div class="producer-flow-header">
    <div>
      <h6 class="title">Agency Appointment Required</h6>
    </div>

    <!-- <button *ngIf="isPopupMode" type="button" class="close-btn" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">x</span>
    </button> -->
  </div>

  <div class="action-banner">
    <div>
<span class="icon"><p class="pi pi-exclamation-triangle"></p></span>
    </div>
    
    <div>
      <p class="banner-title">Action required before submitting quotes.</p>
      <p class="banner-text">Complete the Producerflow appointment form below to access your full Compass portal.</p>
    </div>
  </div>

  <section class="appointment-card">
    <h3 class="card-title">Agent + Appointment Info</h3>

    <div class="agent-details-grid">
      <div class="detail-item">
        <span class="label">Agent Name</span>
        <span class="value">{{ agentName }}</span>
      </div>
      <div class="detail-item">
        <span class="label">Agency</span>
        <span class="value">{{ agencyName }}</span>
      </div>
      <div class="detail-item">
        <span class="label">NPN</span>
        <span class="value">{{ npn }}</span>
      </div>
      <!-- <div class="detail-item">
        <span class="label">License</span>
        <span class="value">{{ licenseStatus }}</span>
      </div> -->
      <div class="detail-item email-item">
        <span class="label">Email</span>
        <span class="value">
          <span>{{ email }}</span>
          <i class="pi pi-check-circle email-check-icon" aria-hidden="true"></i>
        </span>
      </div>
    </div>

    <div class="onboarding-content">
      <p class="onboarding-title">Your personalized onboarding link is ready - via <strong style="color: var(--primary);">Producerflow</strong></p>
      <p class="onboarding-description">
        This link is unique to your agent record. Your name, agency and NPN have been prefilled by Compass -
        no redundant entry needed. Click below to copy and paste the direct link, or open the secure form in a new tab.
      </p>

      <div class="onboarding-actions">
       <button type="button" class="primary" (click)="continueToProducerFlow()">
  <span class="icon">
    <svg width="16" height="16" viewBox="0 0 24 24">
      <path fill="white"
        d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3z"/>
      <path fill="white"
        d="M5 5h5v2H7v10h10v-3h2v5H5z"/>
    </svg>
  </span>
  Open Onboarding Form
</button>

        <div class="link-copy-group">
          <div class="link-input-wrap">
            <input class="link-preview" [value]="onboardingUrl" [title]="onboardingUrl" readonly aria-label="Onboarding link" />
            <i class="pi pi-question-circle help-icon" aria-hidden="true"></i>
          </div>

          <button type="button" class="copy-link-btn" [class.copied]="isCopied" (click)="copyOnboardingLink()">
            <span class="copy-icon" *ngIf="!isCopied" aria-hidden="true"></span>
            <i class="pi pi-check copied-check-icon" *ngIf="isCopied" aria-hidden="true"></i>
            <span>{{ isCopied ? 'Copied' : 'Copy Link' }}</span>
          </button>
        </div>
      </div>

      <div class="help-row">
        <div class="help-item">
          <p class="help-label">Need help?</p>
          <a class="support-link" [href]="'mailto:' + supportEmail">help&#64;greenshieldrisk.com</a>
          <p class="help-text">Mon-Fri, 8am-6pm CT</p>
          <!-- <p class="help-text">Reference ID: {{ agentId }}</p> -->
        </div>

        <!-- <div class="help-item turnaround">
          <p class="help-label">Typical turnaround</p>
          <p class="help-text">is {{ turnaroundText }}</p>
        </div> -->
     
        
      </div>
         <hr>
      <div class="onboarding-description">
            <p>You will be able to access Compass features once your appointment with Green Shield has been completed and approved.
 </p>
        </div>
    </div>
   
  </section>
  <div class="d-flex justify-content-end align-items-center mt-2">
      <button class="primary exit-btn" (click)="redirectToHomePage()">Exit</button>
      </div>
</div>
